/* eslint-disable */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import axios from "axios";
import { convertLocalImageToBase64 } from '../../utils/imageUtils';

export const generatePdfExamen = async (exameneSeleccionados, pacientes) => {
    try {
        const imageUrl = await convertLocalImageToBase64('/img/certificados/padre.png');
        const footerImageUrl = await convertLocalImageToBase64('/img/certificados/footer-receta.png');

        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [30, 30, 30, 30],
            background: function (currentPage, pageSize) {
                return {
                    image: imageUrl, // Imagen de fondo
                    width: 400, // Ajusta el tamaño según necesidad
                    absolutePosition: { x: (pageSize.width - 400) / 2, y: (pageSize.height - 400) / 2 }, // Centrado
                    opacity: 0.07 // Transparencia de la marca de agua
                };
            },
            content: [
                {
                    columns: [
                        { image: imageUrl, width: 80, margin: [0, 0, 10, 0] }, // Imagen más pequeña
                        {
                            stack: [
                                { text: 'LABORATORIO CLINICO COMUNITARIO', style: 'header' },
                                {
                                    text: [
                                        { text: 'Dirección: ', bold: true },
                                        { text: 'Pasaje e/ Bolivar y Sucre. (Junto a la Botica Comunitaria)' }
                                    ],
                                    style: 'subheader1'
                                },
                                { text: 'El Guabo - El Oro - Ecuador', style: 'subheader1' },

                            ],
                            width: 'auto',
                            alignment: 'center'
                        },

                    ]
                },
                generateLineaEncabezado(),
                {
                    text: [
                        { text: 'Fecha: ', bold: true },
                        { text: new Date().toLocaleDateString() },
                    ],
                    alignment: 'right',
                    fontSize: 9, // Tamaño de fuente reducido
                    margin: [0, 10, 0, 0] // Margen reducido
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Cédula: ', bold: true },
                                { text: pacientes.cedula }
                            ],
                            fontSize: 8, // Tamaño de fuente reducido
                            width: 150,
                        },
                        {
                            text: [
                                { text: 'Edad: ', bold: true },
                                { text: pacientes.edad }
                            ],
                            fontSize: 8, // Tamaño de fuente reducido
                            alignment: 'right',
                            width: 250,
                        }
                    ]
                },
                {
                    text: [
                        { text: 'Nombres: ', bold: true },
                        { text: pacientes.nombres }
                    ],
                    fontSize: 8, // Tamaño de fuente reducido
                    margin: [0, 5, 0, 0]
                },
                // Agregar las categorías y exámenes
                { text: 'ORDEN DE EXÁMEN', style: 'header2', margin: [0, 10, 0, 5] }, // Margen reducido
                ...generateExamenesContent(exameneSeleccionados)
            ],
            footer: function (currentPage, pageCount) {
                return {
                    columns: [
                        { image: footerImageUrl, width: 635, alignment: 'center', margin: [0, -65, 0, 0] }
                    ]
                };
            },
            styles: {
                header: { fontSize: 16, color: '#01365e', bold: true, alignment: 'center', margin: [0, 0, 0, 5] },
                header2: { fontSize: 12, color: '#01365e', bold: true, characterSpacing: 5, alignment: 'center', margin: [0, 0, 0, 10] },
                subheader1: { fontSize: 12, alignment: 'center', margin: [0, 0, 0, 5] },
                subheader2: { fontSize: 12, bold: true, alignment: 'center', margin: [0, 10, 0, 10], characterSpacing: 5, color: '#01365e' },
                section: { fontSize: 8, bold: true, margin: [0, 5, 0, 2] }, // Tamaño de fuente reducido
                content: { fontSize: 7, margin: [0, 1, 0, 1] }, // Tamaño de fuente reducido
                selected: { fontSize: 7, margin: [0, 1, 0, 1], background: 'yellow' } // Estilo para exámenes seleccionados
            },
            defaultStyle: {
                fontSize: 7, // Tamaño de fuente reducido
                columnGap: 5 // Espacio entre columnas reducido
            }
        };

        // Generar y abrir el PDF
        pdfMake.createPdf(docDefinition).open();

    } catch (error) {
        console.error("Error al generar el PDF:", error);
    }
};

// Función para generar el contenido de los exámenes en 3 columnas
function generateExamenesContent(exameneSeleccionados) {
    const examenes = [
        { name: "Hematología", items: ["Biometría Hemática Completa", "Eritrosedimentación", "Inv. De Hematocrito", "Grupo Sanguíneo", "Reticulocitos", "Anormalidades Citológicas", "Ferritina", "Transferrina", "Ácido Fólico", "Glucosa 6 Fosfato"] },
        { name: "Enzimas", items: ["T.G.O.", "T.G.P.", "Fosf. Alcalina", "G.G.T.", "Fosf. Acida Total", "Amilasa", "Lipasa", "C.P.K.", "C.K.-MB.", "Colinesterasa"] },
        { name: "Hemostasia", items: ["Plaquetas", "T. de Coagulación", "T. de Sangría", "T. de Protrombina", "T. de Tromboplastina", "Fibrinógeno"] },
        { name: "Inmunología", items: ["Helicobacter Pylori IgG - IgM", "Dengue IgG - IgM", "Dengue NS21", "V.I.H.", "Toxoplasma IgG - IgM", "Rubeola IgG - IgM", "Citomegalovirus IgG - IgM", "Herpes I", "Herpes II", "Hep. A", "Hep. B", "Hep. C", "Cisticercos", "Clamidias en sangre", "Mononucleosis Infecciosa", "Tuberculosis sérica", "Complementos C3 - C4", "IgA", "IgM", "IgG", "IgE", "Anticuerpos Antinucleares (ANA)", "Anticuerpos Anti TPO", "Anti-Tiroglobulina", "Anti-Tiroglobulina Anti TPO", "Anti-Péptido Ciclutrulinado", "Ac. Antifosfolípidos", "Ac. Anti-DNA", "Ac. Antifosfolípidos Lúpico"] },
        {
            name: "Química Sanguínea",
            items: [
                "Glucosa", "Glucosa post prandial", "Tolerancia a la Glucosa", "Hb. Glicosilada", "Urea", "Creatinina", "Ácido Úrico",
                "Colesterol", "Colesterol HDL", "Colesterol LDL", "Triglicéridos", "Lípidos Totales", "Proteínas Totales", "Albuminas",
                "Globulinas", "Bilirrubina Total", "Bilirrubina Directa", "Bilirrubina Indirecta"
            ]
        },
        { name: "Hormonas", items: ["T3", "T4", "TSH", "T3 Libre", "T4 Libre", "Prolactina", "Progesterona", "Tiroglobulina", "LH", "F.S.H.", "Estradiol", "Cortisol am", "Cortisol pm", "Insulina", "Beta HCG cuantitativo", "Beta HCG cualitativo"] },
        { name: "Marcadores Tumorales", items: ["PSA Total", "PSA Libre", "Antígeno Carcinoembrionario (CEA)", "Alfafetoproteína (AFP)", "CA 125 (CA de Ovario)", "CA 19-9 (CA de Páncreas)", "CA 15-3 (CA de Mamas)", "CA 72-4 (CA de Estómago)"] },
        { name: "Orina", items: ["Elemental y Microscópico", "Gram de gota Fresca", "Cultivo y Antibiograma", "Microalbuminuria", "Clearance de Creatinina", "Proteínas en Orina 24 horas", "Panel de Drogas"] },
        { name: "Heces", items: ["Coproparasitario", "Seriado", "coprológico", "Sangre Oculta", "Coprocultivo", "Rotavirus", "Azucares Reductores", "Helicobacter en Heces"] },
        { name: "Electrolitos", items: ["Sodio", "Potasio", "Hierro", "Cloro", "Fósforo", "pH", "Calcio", "Magnesio"] },
        { name: "Serología", items: ["A.S.T.O", "P.C.R.", "F.R.", "V.D.R.L.", "Widal Weill Felix", "Brucella Abortus"] },
        { name: "Esputo", items: ["Baciloscopia", "Tinción de Gram", "Cultivo y Antibiograma"] },
        { name: "Bacteriología", items: ["Cultivo y Antibiograma", "Cultivo para Hongos", "KOH", "Coloración de Gram"] }
    ];

    // Mover "Orina" y "Heces" a la columna 3
    const orina = examenes.find(e => e.name === "Orina");
    const heces = examenes.find(e => e.name === "Heces");
    const examenesSinOrinaHeces = examenes.filter(e => e.name !== "Orina" && e.name !== "Heces");

    // Dividir los exámenes en 3 columnas
    const columnContent = [];
    const chunkSize = Math.ceil(examenesSinOrinaHeces.length / 3); // Dividir en 3 partes

    for (let i = 0; i < 3; i++) {
        const start = i * chunkSize;
        const end = start + chunkSize;
        const columnExamenes = examenesSinOrinaHeces.slice(start, end);

        // Agregar "Orina" y "Heces" a la columna 3
        if (i === 2) {
            columnExamenes.push(orina, heces);
        }

        const column = {
            stack: columnExamenes.map((categoria) => [
                { text: categoria.name, style: 'section' },
                {
                    ul: categoria.items.map((item) => {
                        // Verificar si el examen está seleccionado
                        const isSelected = exameneSeleccionados.examenes[categoria.name]?.includes(item);
                        return {
                            text: item,
                            style: isSelected ? 'selected' : 'content' // Aplicar estilo si está seleccionado
                        };
                    })
                }
            ]),
            width: '33%', // Ancho de cada columna
            margin: [0, 0, 5, 0] // Margen entre columnas reducido
        };

        columnContent.push(column);
    }

    // Agregar el campo "Otros" debajo de "Heces" en la columna 3
    if (exameneSeleccionados.otros) {
        columnContent[2].stack.push(
            { text: "Otros", style: 'section' },
            { text: exameneSeleccionados.otros, style: 'selected' }
        );
    }

    return [
        {
            columns: columnContent,
            columnGap: 5 // Espacio entre columnas reducido
        }
    ];
}

function generateLineaEncabezado() {
    return {
        table: {
            widths: ['100%'],
            body: [
                [
                    {
                        text: '',
                        fillColor: '#01365e',
                        border: [false, false, false, false],
                        height: 1
                    }
                ]
            ]
        },
        layout: 'noBorders'
    };
}

async function downloadImage(url) {
    try {
        const response = await axios.get(url, { responseType: 'blob' });
        const blob = response.data;

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error al descargar la imagen:', error);
        throw error;
    }
}